/**
 * Adzuki.ImageCropper
 */

(function ImageCropper($, Adzuki)
{
	"use strict";

	var $modal = $(".modal");

	var imageCropper = function initImageCropper(el, options)
	{
		var $inputElement,
		    $hiddenFile,
		    valid_image_types = ['image/jpeg', 'image/png', 'image/gif'],
		    default_opts      = {
		        dragMode        : 'move',
		        autoCropArea    : 1,
				rotatable       : true,
				checkOrientation: false
		    },
		    cropper_opts      = $.extend({}, default_opts, options),
		    cropped           = false,
		    aspect_ratio      = 1,
		    image_width       = 0,
		    min_image_width   = 0,
		    image_height      = 0,
		    min_image_height  = 0,
		    image_stretch     = false,
		    image_rounded     = false,
		    image_type,
		    image_name,
		    _fr;

		try
		{
			// el will be a non-jQuery object when iterating a collection
			// of elements returned by a jQuery selector, eg. $("input.file");
			// if it's a string or non-jQuery object, wrap in a jQuery object.
			if (typeof el === 'string' ||
			    typeof el === 'object' && !(el instanceof jQuery)) {
				$inputElement = $(el);
			}
			else if (typeof el === 'object' && (el instanceof jQuery)) {
				$inputElement = el;
			}

			if ($inputElement.cropper === undefined) {
				throw new Error('cropper.js not loaded');
			}

			if ($inputElement.data('form-name') === undefined) {
				throw new Error('missing form name');
			}

			// this is done inside the constructor beacuse each FileReader needs
			// it's own onload event handler, so you can use different el & opts
			initFileReader();
		}
		catch (err)
		{
			console.error('[Adzuki.ImageCropper]', err);
		}

		$hiddenFile = $('<input type="hidden" name="'+$inputElement.attr('name')+'" id="'+$inputElement.attr('id')+'">');

		$inputElement.removeAttr('name');

		$hiddenFile.insertAfter($inputElement);

		if ($inputElement.data('form-width') !== undefined) {
			image_width = parseInt($inputElement.data('form-width'));
		}

		if ($inputElement.data('form-height') !== undefined) {
			image_height = parseInt($inputElement.data('form-height'));
		}

		if ($inputElement.data('form-minwidth') !== undefined) {
			min_image_width = parseInt($inputElement.data('form-minwidth'));
		}

		if ($inputElement.data('form-minheight') !== undefined) {
			min_image_height = parseInt($inputElement.data('form-minheight'));
		}

		if ($inputElement.data('form-stretch') !== undefined && ($inputElement.data('form-stretch') === 'true' || $inputElement.data('form-stretch') === 1)) {
			image_stretch = true;
		}

		if (image_width > 0 && image_height > 0) {
			aspect_ratio                = image_width / image_height;
			cropper_opts['aspectRatio'] = aspect_ratio;
		}

		if (min_image_width > 0) {
			cropper_opts['minCropBoxWidth'] = min_image_width;
		}

		if (min_image_height > 0) {
			cropper_opts['minCropBoxHeight'] = min_image_height;
		}

		$inputElement.on('change', function selectedImage()
		{
			// the browsers we target with adzuki all support this stuff
			// but double-checking never hurt anybody
			if (!this.files || !this.files[0]) {
				return;
			}

			image_type = this.files[0].type;
			image_name = this.files[0].name;

			if (valid_image_types.indexOf(image_type) < 0) {
				Adzuki.StatusMessage('Error', 'Invalid file.');
				$inputElement.val('');
				return;
			}

			_fr.readAsDataURL(this.files[0]);
		});

		$inputElement.on('click', resetFileReader);

		function resetFileReader()
		{
			var $hiddenImage    = $('input[name="'+$inputElement.data('form-name')+'[image]"]'),
			    $hiddenSettings = $('input[name="'+$inputElement.data('form-name')+'[settings]"]'),
			    $thumbnail      = $('img[data-name="'+$inputElement.data('form-name')+'[image]"]');

			if ($hiddenImage.length) {
				$hiddenImage.remove();
			}

			if ($hiddenSettings.length) {
				$hiddenSettings.remove();
			}

			if ($thumbnail.length) {
				$thumbnail.remove();
			}

			$inputElement.val('');
		}

		function initFileReader()
		{
			_fr = new FileReader();

			// this load is fired (pause) when a file is done being read
			_fr.addEventListener('load', function finishedReadingImage(e)
			{
				var $img            = $("<img>").addClass('croppable').prop('src', e.target.result),
				    $hiddenImage    = $('input[name="'+$inputElement.data('form-name')+'[image]"]'),
				    $hiddenSettings = $('input[name="'+$inputElement.data('form-name')+'[settings]"]'),
				    $thumbnail      = $('img[data-name="'+$inputElement.data('form-name')+'[image]"]');

				if (!$hiddenImage.length) {
					$hiddenImage = $('<input type="hidden" name="'+$inputElement.data('form-name')+'[image]" class="cropper-data">');
				}

				if (!$hiddenSettings.length) {
					$hiddenSettings = $('<input type="hidden" name="'+$inputElement.data('form-name')+'[settings]" class="cropper-data">');
				}

				if (!$thumbnail.length) {
					$thumbnail = $("<img>").addClass('cropped-image-thumbnail').attr('data-name', $inputElement.data('form-name')+'[image]');
				}

				$modal.find('.modal-title').text($inputElement.prop('title'));
				$modal.find('.modal-body').html($img);

				if (!$modal.find('.btn.crop').length) {
					$modal.find('.modal-footer').prepend('<button class="btn btn-primary crop">Select Cropped Area</button>');
				}

				// for round images
				if ($inputElement.data('roundable')) {
					if (!$modal.find('.shape-select').length) {
						$modal.find('.modal-footer').prepend('<span class="shape-select"><input type="radio" class="shape-change" name="shape" value="round"> round&nbsp;&nbsp;&nbsp;<input type="radio" class="shape-change" name="shape" value="standard" checked> standard&nbsp;&nbsp;&nbsp;</span>');
					}

					$modal.on('change', '.shape-change', function toggleShape() {
						var is_rounded = this.value === 'round';
						$modal.toggleClass('cropper round', is_rounded);
						image_rounded = is_rounded;

						if (is_rounded) {
							cropper_opts['aspectRatio'] = 1;
						}
						else {
							cropper_opts['aspectRatio'] = aspect_ratio;
						}

						$img.cropper('destroy').cropper(cropper_opts);
					});
				}

				$modal.on('shown.bs.modal', function _initCropper() {
					$img.cropper(cropper_opts);
				});

				$modal.on('click', 'button.crop', function _setImageCropper() {
					var canvas   = $img.cropper('getCroppedCanvas'),
					    settings = {
					        width  : image_width,
					        height : image_height,
					        stretch: image_stretch,
					        type   : image_type,
					        name   : image_name,
					    },
					    b64,
					    round_canvas,
					    filename_parts;

					if (image_rounded) {
						// force png cause it supports transparency
						filename_parts = settings.name.split('.');
						filename_parts[filename_parts.length-1] = 'png';
						round_canvas  = getRoundedCanvas(canvas);
						b64           = round_canvas.toDataURL('image/png');
						settings.type = 'image/png';
						settings.name = filename_parts.join('.');
					}
					else {
						b64 = canvas.toDataURL(image_type);
					}

					$hiddenImage.val(b64).insertAfter($inputElement);
					$hiddenSettings.val(JSON.stringify(settings)).insertAfter($hiddenImage);

					if ($inputElement.data('form-thumbnail') !== undefined && ($inputElement.data('form-thumbnail') === 'true' || $inputElement.data('form-thumbnail') === 1)) {
						$thumbnail.prop('src', b64).insertAfter($inputElement);
					}

					cropped = true;
					$('.cropper-data').trigger('change');
					$modal.modal('hide');

					$inputElement.trigger('adzuki.cropped', $.extend(
						{}, settings, {
							image_data: b64,
							shape     : (image_rounded) ? 'round' : 'standard',
						}
					));
				});

				$modal.on('hidden.bs.modal', function _restoreModal() {
					if (cropped) {
						cropped = false;
					} else {
						resetFileReader();
					}

					$img.cropper('destroy');
					$modal.off('click', 'button.crop')
					      .off('shown.bs.modal')
					      .off('hidden.bs.modal')
					      .removeClass('cropper round')
					      .find('.btn.crop').remove();
					$modal.find('.shape-select').remove();
				});

				$modal.modal({
				    backdrop: 'static'
				}).modal('show');

			});
		}

		function getRoundedCanvas(sourceCanvas) {
			var canvas = document.createElement('canvas');
			var context = canvas.getContext('2d');
			var width = sourceCanvas.width;
			var height = sourceCanvas.height;

			canvas.width = width;
			canvas.height = height;
			context.imageSmoothingEnabled = true;
			context.drawImage(sourceCanvas, 0, 0, width, height);
			context.globalCompositeOperation = 'destination-in';
			context.beginPath();
			context.arc(width / 2, height / 2, Math.min(width, height) / 2, 0, 2 * Math.PI, true);
			context.fill();
			return canvas;
		}
	};

	Adzuki.ImageCropper = imageCropper;
}(jQuery, window.Adzuki || {}));
